<template>
  <div class="page home">
    <div class="venues-background"></div>
    <PageHeader />
    <div v-if="slideDetailShow" id="slide-detail">
      <img src="@/assets/close2.svg" id="close-modal-button" @click="onClick" />
      <div class="slide-detail-wrapper">
        <div class="slide-detail-content">
          <template v-if="$route.params.season == 'SPRING'">
            <p>
              The O-RAN ALLIANCE organizes regular PlugFests to accelerate the
              development of O-RAN based products and solutions by offering
              structured testing and integration opportunities in a neutral and
              collaborative environment.
            </p>
            <p>
              Building on achievements from previous PlugFests, the O-RAN Global
              PlugFest Spring 2026 furthered multi-vendor end-to-end
              integrations of massive MIMO O-RAN-based components, including
              mMIMO beamforming. Several labs focused on AI RAN solutions that
              improve network performance and advance energy savings. PlugFest
              efforts also led to successful establishment of special testing
              environments, such as over-the-air testing, anechoic chamber,
              shared O-RU, and deployment of open source software: Open Air
              Interface (OAI), OCUDU, O-RAN SC, and Sylva. Initial tests were
              performed on Integrated Sensing and Communication (ISAC).
            </p>
            <p>
              The O-RAN Global PlugFest Spring 2026 was hosted by 13 operators,
              Open Testing and Integration Centres (OTICs) and independent
              institutions in 9 labs around the world. It was conducted from
              February to May 2026 with a total of 31 participating companies,
              some of which were involved in multiple venues.
            </p>
            <p>
              “O-RAN PlugFests greatly help address the complexity of
              disaggregated network solutions. At the same time, they allow
              exploring new directions or proofs of concept,” said Brian Daly,
              Co-chair of the O-RAN Technical Steering Committee and AVP at AT&T
              Services. “Each PlugFest builds operational and management
              experience that directly improves the efficiency of the next
              iteration. It is great to see such activity and collaboration
              across the O-RAN industry ecosystem.”
            </p>
          </template>
          <template v-if="$route.params.season == 'FALL'"> </template>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="col card" @click="onShowHideSlideDetail">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="80"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide>
            <div class="card-wrapper">
              <div class="card-content">
                <div class="card-image">
                  <template v-if="$route.params.season == 'SPRING'">
                    <img alt="News" src="@/assets/news_01.jpg" />
                  </template>
                  <template v-if="$route.params.season == 'FALL'">
                    <img alt="News" src="@/assets/news_02.png" />
                  </template>
                </div>

                <div class="card-title"></div>
                <div class="card-title-text">
                  <template v-if="$route.params.season == 'SPRING'">
                    O-RAN Global PlugFest Spring 2026 was co-hosted by 13
                    operators, OTICs and academics and research institutions.
                  </template>
                  <template v-if="$route.params.season == 'FALL'"> </template>
                </div>
                <div class="card-description">
                  <div>
                    <template v-if="$route.params.season == 'SPRING'">
                      O-RAN Global PlugFest Spring 2026 was conducted from
                      February to May 2026 in 9 labs around the world with a
                      total of 31 participating companies, some of which were
                      involved in multiple venues.
                    </template>
                    <template v-if="$route.params.season == 'FALL'"> </template>
                  </div>
                </div>
                <div class="card-read-more">
                  <template v-if="!slideDetailShow"
                    ><div>Read more</div></template
                  >
                  <template v-else><div>Close</div></template>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="col venues-items">
        <Venues
          :data="venues"
          :showSwitch="true"
          title="Select PlugFest venue to explore"
          :showScrenariosCombo="false"
        />
      </div>
    </div>

    <Participants
      v-if="alphabet"
      :data="alphabet"
      title="O-RAN Global PlugFest Spring/Fall 2026 Participants"
    />
    <Footer backgroundDirection="left" />
  </div>
</template>

<script src="./Home2026.js"></script>
